import axios from 'axios';

const EXTRACT_URL = import.meta.env.VITE_APP_EXTRACT_URL;

// `import.meta.env.MODE` is "production" for every build (dev/demo/prod/iOS all
// run `vite build` with no --mode), so it can't tell environments apart. Derive
// the environment from the actual backend instead: VITE_TARGET (set by the
// Dockerfile for dev/demo/preview web builds) when present, otherwise infer from
// the API host (always baked in — works for prod-S3 and local iOS/TestFlight).
const resolveEnvironment = (): string => {
  const target = import.meta.env.VITE_TARGET;
  if (target) return target;

  const apiHost = (import.meta.env.VITE_APP_AUTH_URL ?? '').toLowerCase();
  if (apiHost.includes('dev.')) return 'dev';
  if (apiHost.includes('demo.')) return 'demo';
  if (apiHost.includes('app.vesselhaven.com')) return 'production';

  return import.meta.env.MODE;
};

/** Build environment: 'dev' | 'demo' | 'preview' | 'production'. */
export const APP_ENV = resolveEnvironment();

// The AI service is deployed twice: production, and one shared demo stack that
// dev, demo and preview all point at.
const BACKEND_ENV = APP_ENV === 'production' ? 'production' : 'demo';

export const BACKEND_ENV_HEADER = { 'X-Backend-Env': BACKEND_ENV };

/**
 * Stamps X-Backend-Env on every bare-`axios` call to VITE_APP_EXTRACT_URL
 * (all /api/ai endpoints). Only the default axios instance is touched — the
 * `axios.create()` instances in src/api/api.ts keep their own interceptors.
 * `fetch`-based AI calls add the header themselves via BACKEND_ENV_HEADER.
 */
export const initBackendEnvHeader = () => {
  axios.interceptors.request.use((config) => {
    if (EXTRACT_URL && config.url?.startsWith(EXTRACT_URL)) {
      config.headers['X-Backend-Env'] = BACKEND_ENV;
    }
    return config;
  });
};
